var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Users"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(_vm.pagination)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _c("b", [_vm._v("Filters:")]),
                      ]),
                      _vm._v(" "),
                      _vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-up")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-down")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showFilters
                    ? _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs11: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Id",
                                              rules: [_vm.rules.numeric],
                                            },
                                            model: {
                                              value: _vm.id,
                                              callback: function ($$v) {
                                                _vm.id = $$v
                                              },
                                              expression: "id",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.organizations,
                                              label: "Organization",
                                              "item-text": "text",
                                              "item-value": "value",
                                            },
                                            model: {
                                              value: _vm.orgId,
                                              callback: function ($$v) {
                                                _vm.orgId = $$v
                                              },
                                              expression: "orgId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Deleted",
                                              items: _vm.deletedItems,
                                            },
                                            model: {
                                              value: _vm.deleted,
                                              callback: function ($$v) {
                                                _vm.deleted = $$v
                                              },
                                              expression: "deleted",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Collection Agent",
                                              items: _vm.collAgentItems,
                                            },
                                            model: {
                                              value: _vm.collectionAgent,
                                              callback: function ($$v) {
                                                _vm.collectionAgent = $$v
                                              },
                                              expression: "collectionAgent",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "External",
                                              items: _vm.externalItems,
                                            },
                                            model: {
                                              value: _vm.isExternal,
                                              callback: function ($$v) {
                                                _vm.isExternal = $$v
                                              },
                                              expression: "isExternal",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Name" },
                                            model: {
                                              value: _vm.name,
                                              callback: function ($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Login" },
                                            model: {
                                              value: _vm.login,
                                              callback: function ($$v) {
                                                _vm.login = $$v
                                              },
                                              expression: "login",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      onsubmit: "false",
                                      disabled: !_vm.valid,
                                    },
                                    on: { click: _vm.applyFilters },
                                  },
                                  [_vm._v("Apply")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { onsubmit: "false" },
                                    on: { click: _vm.resetFilters },
                                  },
                                  [_vm._v("Reset")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.users.content,
                              loading: _vm.loading,
                              headers: _vm.headers,
                              options: _vm.pagination,
                              "footer-props": {
                                "items-per-page-options": [
                                  5, 10, 15, 20, 50, 100,
                                ],
                              },
                              "server-items-length": _vm.totalItems,
                            },
                            on: {
                              "update:options": function ($event) {
                                _vm.pagination = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.name",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _vm.isSUPro
                                          ? _c(
                                              "router-link",
                                              {
                                                attrs: { to: "" },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.editItem(item)
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          : _c("span", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.updatedDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(item.updatedDate)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.deleted",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(item.deleted ? "yes" : "no")
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.collectionAgent",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          item.collectionAgent === true
                                            ? "yes"
                                            : item.collectionAgent === false
                                            ? "no"
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function ({ item }) {
                                  return [
                                    _vm.isSUPro
                                      ? _c(
                                          "td",
                                          { staticClass: "actions" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticStyle: {
                                                  height: "0px",
                                                  width: "0px",
                                                  "padding-right": "2px",
                                                },
                                                attrs: { text: "", icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editItem(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                    attrs: {
                                                      color: "grey lighten-1",
                                                    },
                                                  },
                                                  [_vm._v("fas fa-pencil")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.showEditUserDialog,
                callback: function ($$v) {
                  _vm.showEditUserDialog = $$v
                },
                expression: "showEditUserDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [_vm._v("User")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.validUser,
                            callback: function ($$v) {
                              _vm.validUser = $$v
                            },
                            expression: "validUser",
                          },
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "subheading",
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                               Id: " +
                                          _vm._s(_vm.editedItem.id) +
                                          " OrgId: " +
                                          _vm._s(_vm.editedItem.org.id) +
                                          " (" +
                                          _vm._s(_vm.editedItem.org.name) +
                                          ")\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [_vm.rules.required],
                                          label: "Name",
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Login" },
                                        model: {
                                          value: _vm.editedItem.login,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "login",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.login",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Phone" },
                                        model: {
                                          value: _vm.editedItem.phone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "phone",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.phone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Email" },
                                        model: {
                                          value: _vm.editedItem.email,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.email",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Deleted" },
                                        model: {
                                          value: _vm.editedItem.deleted,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "deleted",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.deleted",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "External" },
                                        model: {
                                          value: _vm.editedItem.isExternal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "isExternal",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.isExternal",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Collection Agent" },
                                        model: {
                                          value: _vm.editedItem.collectionAgent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "collectionAgent",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editedItem.collectionAgent",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.authTypes,
                                          label: "Auth Type",
                                        },
                                        model: {
                                          value: _vm.editedItem.authType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "authType",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.authType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: "Communication Opt In",
                                        },
                                        model: {
                                          value:
                                            _vm.editedItem.communicationOptIn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "communicationOptIn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editedItem.communicationOptIn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: { label: "Consent Json" },
                                        model: {
                                          value: _vm.editedItem.consentJson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "consentJson",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.consentJson",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            disabled: !_vm.validUser,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.save.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }